document.addEventListener("DOMContentLoaded", () => {

  // =====================================================
  // Email & Phone Labels
  // =====================================================

  function initContactLabels() {
    document
      .querySelectorAll('a[href^="mailto:"], a[href^="tel:"]')
      .forEach((el) => {
        const href = el.getAttribute("href");

        if (
          el.getAttribute("role") === "button" ||
          el.classList.contains("button") ||
          el.classList.contains("btn")
        ) {
          return;
        }

        // Email
        if (href?.startsWith("mailto:")) {
          const email = href.replace("mailto:", "").split("?")[0].trim();
          const existing = el.getAttribute("aria-label");

          el.setAttribute(
            "aria-label",
            existing
              ? `${existing}, Email address: ${email}`
              : `Email address: ${email}`
          );
        }

        // Phone
        if (href?.startsWith("tel:")) {
          const phone = href.replace("tel:", "").trim();
          const existing = el.getAttribute("aria-label");

          el.setAttribute(
            "aria-label",
            existing
              ? `${existing}, Phone number: ${phone}`
              : `Phone number: ${phone}`
          );
        }
      });
  }

  initContactLabels();


  // =====================================================
  // External Link Warnings
  // =====================================================

  const warningText =
    "Redirecting to a third-party website (opens in a new tab).";

  function isThirdParty(url) {
    try {
      const linkHost = new URL(url, window.location.href).hostname;
      return linkHost && linkHost !== window.location.hostname;
    } catch {
      return false;
    }
  }

  function handleExternalLinks() {
    document.querySelectorAll("a").forEach(function (link) {
      const href = link.getAttribute("href");

      if (!href || !isThirdParty(href)) return;

      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");

      const img = link.querySelector("img");

      if (img) {
        link.removeAttribute("aria-label");

        let alt = img.getAttribute("alt") || "";

        if (!alt.includes(warningText)) {
          img.setAttribute(
            "alt",
            alt ? alt + ", " + warningText : warningText
          );
        }

        return;
      }

      const text = link.textContent.trim();

      if (!text) return;

      const aria = link.getAttribute("aria-label");

      if (!aria || !aria.includes(warningText)) {
        link.setAttribute(
          "aria-label",
          text + ", " + warningText
        );
      }
    });
  }

  setTimeout(handleExternalLinks, 500);


  // =====================================================
  // Cart Drawer
  // =====================================================

  // function getFocusableElements(container) {
  //   return [
  //     ...container.querySelectorAll(`
  //       a[href],
  //       button:not([disabled]),
  //       input:not([disabled]),
  //       textarea:not([disabled]),
  //       select:not([disabled]),
  //       [tabindex]:not([tabindex="-1"])
  //     `),
  //   ].filter((el) => {
  //     return (
  //       el.offsetParent !== null &&
  //       !el.hasAttribute("disabled") &&
  //       el.getAttribute("aria-hidden") !== "true"
  //     );
  //   });
  // }

  // function initCartDrawer() {
  //   document.addEventListener("keydown", (e) => {
  //     if (!cartDrawer.classList.contains("open")) return;
  //     if (e.key !== "Tab") return;

  //     const focusable = getFocusableElements(cartDrawer);

  //     if (!focusable.length) return;

  //     const first = focusable[0];
  //     const last = focusable[focusable.length - 1];

  //     if (e.shiftKey && document.activeElement === first) {
  //       e.preventDefault();
  //       last.focus();
  //     } else if (!e.shiftKey && document.activeElement === last) {
  //       e.preventDefault();
  //       first.focus();
  //     }
  //   });
  // }

  // initCartDrawer();


  // =====================================================
  // Gift Note Toggle
  // =====================================================

  function initGiftNote() {
    document.addEventListener("click", (e) => {
      const btn = e.target.closest(".js-show-note");

      if (!btn) return;

      const panel = document.getElementById(
        btn.getAttribute("aria-controls")
      );

      if (!panel) return;

      const expanded =
        btn.getAttribute("aria-expanded") === "true";

      btn.setAttribute("aria-expanded", !expanded);
      panel.hidden = expanded;

      btn.textContent = expanded
        ? "Add Gift Note"
        : "Hide Gift Note";

      if (!expanded) {
        panel.querySelector("textarea")?.focus();
      }
    });
  }

  initGiftNote();



  // =====================================================
  // Site Credits Modal
  // =====================================================

  function initSiteCreditsDialog() {
    const trigger = document.getElementById("site-credits-trigger");
    const dialog = document.getElementById("site-credits-dialog");

    if (!trigger || !dialog) return;

    const closeBtn = dialog.querySelector(".js_close_site_credits");

    if (!closeBtn) return;

    // Existing dialog code here...
  }

  initSiteCreditsDialog();


  // =====================================================
  // Product Tabs
  // =====================================================

  function initProductTabs() {
    const tabList = document.querySelector(".product-tabs-nav ul");

    const tabs = [
      ...document.querySelectorAll(
        ".product-tabs-nav .js_input_swap"
      ),
    ];

    if (!tabList || !tabs.length) return;

    // Existing tab code here...
  }

  initProductTabs();


// =============================== NAvigation script Desktop ==============
(() => {
  const triggers = [...document.querySelectorAll(".js_dropdown_trigger, .js_dropdown_filter_navigation")];
  const dropdowns = [...document.querySelectorAll(".navigation_dropdown, .filter_dropdown")];

  let activeTrigger = null;

  // -----------------------------
  // Update aria-expanded
  // -----------------------------
  function syncExpanded() {
    triggers.forEach((trigger, index) => {
      trigger.setAttribute(
        "aria-expanded",
        dropdowns[index].classList.contains("is-open")
      );
    });
  }

  // -----------------------------
  // Watch dropdown open/close
  // -----------------------------
  dropdowns.forEach((dropdown, index) => {
    const observer = new MutationObserver(() => {
      const isOpen = dropdown.classList.contains("is-open");

      triggers[index].setAttribute("aria-expanded", isOpen);

      if (isOpen) {
        activeTrigger = triggers[index];

        // Wait for animation to finish
        setTimeout(() => {
          const closeBtn = dropdown.querySelector(
            ".Close-shop-btn, .Close-coll-btn, .Close-search-btn, .Close-filter-btn"
          );

          if (closeBtn) {
            closeBtn.focus();
            console.log("✅ Focus moved to:", closeBtn);
          }
        }, 500);
      }
    });

    observer.observe(dropdown, {
      attributes: true,
      attributeFilter: ["class"],
    });
  });

  // -----------------------------
  // Return focus
  // -----------------------------
  // -----------------------------
// Close dropdown + Return focus
// -----------------------------
function closeDropdown() {
const openDropdown = document.querySelector(
    ".navigation_dropdown.is-open, .filter_dropdown.is-open"
);

  if (!openDropdown) return;

  // Remove open state
  openDropdown.classList.remove("is-open");

  // Fade out content
  const content = openDropdown.querySelector(
    ".inner_container, .search_container, .flexbox_container"
  );

  if (content) {
    content.style.opacity = "0";
  }

  // Fade out background blur
  const blur = document.querySelector(".navigation_background_blur");

  if (blur) {
    blur.style.opacity = "0";

    setTimeout(() => {
      blur.style.display = "none";
    }, 300);
  }

  // Update aria-expanded
  if (activeTrigger) {
    activeTrigger.setAttribute("aria-expanded", "false");
  }

  // Return focus to the trigger
  setTimeout(() => {
    if (activeTrigger) {
      activeTrigger.focus();
      console.log("↩ Focus returned:", activeTrigger);
    }
  }, 300);
}

  // -----------------------------
  // Close button
  // -----------------------------
  // -----------------------------
// Close button
// -----------------------------
document.addEventListener("click", (e) => {
  const closeBtn = e.target.closest(
    ".Close-shop-btn, .Close-coll-btn, .Close-search-btn, .Close-filter-btn"
  );

  if (!closeBtn) return;

  e.preventDefault();

  closeDropdown();
});

  // -----------------------------
  // ESC
  // -----------------------------
  // -----------------------------
// ESC
// -----------------------------
document.addEventListener("keydown", (e) => {
  if (e.key !== "Escape") return;

 const openDropdown = document.querySelector(
  ".navigation_dropdown.is-open, .filter_dropdown.is-open"
);
  if (!openDropdown) return;

  e.preventDefault();

  closeDropdown();
});

  // Initial state
  syncExpanded();

  console.log("✅ Accessibility helper loaded");
})();

// Cart button 

// Focus management for the cart

document.addEventListener("keydown", (e) => {
  if (e.key !== "Escape") return;
 
  const cartClose = document.querySelector(".cart-close");
  if (!(cartClose instanceof HTMLElement)) return;
 
  cartClose.click();
});
 
document.addEventListener("click", (e) => {
  if (!(e.target instanceof Element)) return;
 
  // Cart opened -> focus close button
  if (e.target.closest(".header-cart-button")) {
    setTimeout(() => {
      const cartCloseBtn = document.querySelector(".cart-close");
      if (cartCloseBtn instanceof HTMLElement) cartCloseBtn.focus();
    }, 100);
  }
 
  // Cart closed -> focus back to header cart button
  if (e.target.closest(".cart-close")) {
    setTimeout(() => {
      const headerCartBtn = document.querySelector(".header-cart-button");
      if (headerCartBtn instanceof HTMLElement) {
        headerCartBtn.focus({ preventScroll: true });
      }
    }, 100);
  }
});

// #######################  Filter JS query ############################

(() => {

  // ===========================
  // Elements
  // ===========================
  const trigger = document.querySelector(".js_dropdown_filter_navigation");
  const wrapper = document.getElementById("filter-dropdown");

  if (!trigger || !wrapper) {
    console.warn("Filter accessibility: Required elements not found.");
    return;
  }

  const closeButtonSelector =
    "button.js_toggle_filter_nav_desktop.close_filter";

  let lastState = wrapper.classList.contains("is-open");

  // ===========================
  // Sync trigger state only
  // (DO NOT touch aria-hidden)
  // ===========================
  function syncTrigger() {
    const isOpen = wrapper.classList.contains("is-open");

    trigger.setAttribute("aria-expanded", isOpen);

    return isOpen;
  }

  syncTrigger();

  // ===========================
  // Watch filter open / close
  // ===========================
  const observer = new MutationObserver(() => {

    const isOpen = syncTrigger();

    if (isOpen === lastState) return;

    lastState = isOpen;

    if (isOpen) {

      // Wait until opening animation finishes
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {

          const closeBtn = wrapper.querySelector(closeButtonSelector);

          if (closeBtn) {

            closeBtn.focus({
              preventScroll: true
            });

            console.log("Focus moved to Close button");

          }

        });
      });

    } else {

      // Return focus after theme closes dialog
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {

          trigger.focus({
            preventScroll: true
          });

          console.log("Focus returned to Filter button");

        });
      });

    }

  });

  observer.observe(wrapper, {
    attributes: true,
    attributeFilter: [
      "class",
      "aria-hidden"
    ]
  });

  // ===========================
  // Escape closes filter
  // ===========================
  document.addEventListener("keydown", e => {

    if (e.key !== "Escape") return;

    if (!wrapper.classList.contains("is-open")) return;

    e.preventDefault();

    const closeBtn = wrapper.querySelector(closeButtonSelector);

    if (closeBtn) {

      closeBtn.click();

    }

  });

  // ===========================
  // Hidden span support
  // ===========================
  const hiddenClose = wrapper.querySelector(
    "span.Close-filter-btn"
  );

  if (hiddenClose && !hiddenClose.dataset.bound) {

    hiddenClose.dataset.bound = "true";

    function activate(e) {

      if (
        e.type === "click" ||
        e.key === "Enter" ||
        e.key === " "
      ) {

        e.preventDefault();

        wrapper.querySelector(closeButtonSelector)?.click();

      }

    }

    hiddenClose.addEventListener(
      "click",
      activate
    );

    hiddenClose.addEventListener(
      "keydown",
      activate
    );

  }

  console.log("✅ Filter accessibility helper loaded");

})();


// ##################################### Filter Mobile JS Query ############################
(() => {

    // ===========================
    // CONFIG
    // ===========================

    const trigger = document.querySelector(
        ".js_slidetoggle_filter_nav_mobile.mobile"
    );

    const drawer = document.getElementById("mobile-filter-dialog");

    if (!trigger || !drawer) {
        console.warn("Mobile filter dialog not found.");
        return;
    }

    const closeBtn = drawer.querySelector(
        ".close_icon .js_slidetoggle_filter_nav_mobile"
    );

    let isOpen = drawer.getAttribute("aria-hidden") === "false";

    // ===========================
    // Utility
    // ===========================

    function getFocusable() {
        return [...drawer.querySelectorAll(
            'button:not([disabled]),a[href],input,select,textarea,[tabindex]:not([tabindex="-1"])'
        )].filter(el => el.offsetParent !== null);
    }

    function updateState(open) {

        trigger.setAttribute("aria-expanded", String(open));
        drawer.setAttribute("aria-hidden", String(!open));

        isOpen = open;

        console.log(
            open
                ? "Drawer Open"
                : "Drawer Closed"
        );
    }

    // ===========================
    // Observe drawer open/close
    // ===========================

    const observer = new MutationObserver(() => {

        const visible =
            drawer.classList.contains("is-open") ||
            drawer.getAttribute("aria-hidden") === "false";

        if (visible === isOpen) return;

        updateState(visible);

        if (visible) {

            requestAnimationFrame(() => {

                closeBtn?.focus();

                console.log("Focus -> Close");

            });

        } else {

            requestAnimationFrame(() => {

                trigger.focus();

                console.log("Focus -> Trigger");

            });

        }

    });

    observer.observe(drawer, {
        attributes: true,
        attributeFilter: [
            "class",
            "aria-hidden"
        ]
    });

    // ===========================
    // ESC
    // ===========================

    document.addEventListener("keydown", e => {

        if (!isOpen) return;

        if (e.key !== "Escape") return;

        e.preventDefault();

        console.log("ESC pressed");

        closeBtn?.click();

    });

    // ===========================
    // Focus Trap
    // ===========================

    drawer.addEventListener("keydown", e => {

        if (!isOpen) return;

        if (e.key !== "Tab") return;

        const items = getFocusable();

        if (!items.length) return;

        const first = items[0];
        const last = items[items.length - 1];

        if (e.shiftKey) {

            if (document.activeElement === first) {

                e.preventDefault();

                last.focus();

            }

        } else {

            if (document.activeElement === last) {

                e.preventDefault();

                first.focus();

            }

        }

    });

    // ===========================
    // Accordions
    // ===========================

    drawer.querySelectorAll(
        ".js_toggle_mobile_filter_accordion_input"
    ).forEach(button => {

        const id = button.getAttribute("aria-controls");

        if (!id) return;

        const panel = drawer.querySelector("#" + id);

        if (!panel) return;

        panel.hidden = true;

        button.setAttribute("aria-expanded", "false");

        button.addEventListener("click", () => {

            const expanded =
                button.getAttribute("aria-expanded") === "true";

            button.setAttribute(
                "aria-expanded",
                String(!expanded)
            );

            panel.hidden = expanded;

        });

    });

    // ===========================
    // Trigger click
    // ===========================

    trigger.addEventListener("click", () => {

        setTimeout(() => {

            updateState(true);

            closeBtn?.focus();

        }, 200);

    });

    // ===========================
    // Close button
    // ===========================

    closeBtn?.addEventListener("click", () => {

        setTimeout(() => {

            updateState(false);

            trigger.focus();

        }, 100);

    });

    console.log("✅ Mobile Accessibility Helper Loaded");

})();
let lastFocusedButton = null;

// Save the button that opened the dialog
document
  .querySelectorAll(
    ".js_toggle_mobile_nav:not(.close_mobile_nav), .js_toggle_search_nav_mobile"
  )
  .forEach((button) => {
    button.addEventListener("click", function () {
      lastFocusedButton = this;

      setTimeout(() => {
        const closeButton = document.querySelector(
          ".close_mobile_nav, .close_mobile_search"
        );

        closeButton?.focus();
      }, 1000);
    });
  });

// Restore focus to the button that opened the dialog
document
  .querySelectorAll(".close_mobile_nav, .close_mobile_search")
  .forEach((button) => {
    button.addEventListener("click", () => {
      setTimeout(() => {
        lastFocusedButton?.focus();
      }, 1000);
    });
  });
});
